import React from 'react';
import styled from 'styled-components';
import { Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function DayPickerNavbar({
  month,
  previousMonth,
  nextMonth,
  onPreviousClick,
  onNextClick,
  className
}) {
  return (
    <div className={className}>
      <Button className="prev" onClick={() => onPreviousClick()}>
        <FontAwesomeIcon icon="chevron-left" aria-label="Previous month" />
      </Button>
      <span />
      <Button className="next" onClick={() => onNextClick()}>
        <FontAwesomeIcon icon="chevron-right" aria-label="Next month" />
      </Button>
    </div>
  );
}

const StyledDayPickerNavbar = styled(DayPickerNavbar)`
  overflow: hidden;

  button {
    margin: 0;
    width: 3em;
    border-radius: 0;
    border: 0;
    background-color: ${props => props.theme.buttons.primary.backgroundColor};
  }

  .prev {
    float: left;
  }

  .next {
    float: right;
  }

  & + .DayPicker-Months {
    .DayPicker-Month {
      margin-top: 0.3em;
    }

    .DayPicker-Caption {
      text-align: center;

      & > div {
        position: absolute;
        top: 0.25em;
        left: 4em;
      }
    }
  }
`;

export default StyledDayPickerNavbar;
